/* this file is transformed by vux-loader */
/* eslint-disable */
import "core-js/modules/es.number.constructor.js";
import "core-js/modules/es.object.to-string.js";
import "core-js/modules/es.regexp.to-string.js";
import "core-js/modules/es.string.match.js";
import "core-js/modules/es.regexp.exec.js";
//
//
//
//
//
//
//
//
//
//

/* eslint-disable */
import objectAssign from 'object-assign';
import XScroll from 'vux-xscroll/build/cmd/xscroll.js';
import Pulldown from 'vux-xscroll/build/cmd/plugins/pulldown';
import Pullup from 'vux-xscroll/build/cmd/plugins/pullup';

var pulldownDefaultConfig = function pulldownDefaultConfig() {
  return {
    content: 'Pull Down To Refresh',
    height: 60,
    autoRefresh: false,
    downContent: 'Pull Down To Refresh',
    upContent: 'Release To Refresh',
    loadingContent: 'Loading...',
    clsPrefix: 'xs-plugin-pulldown-'
  };
};

var pullupDefaultConfig = function pullupDefaultConfig() {
  return {
    content: 'Pull Up To Refresh',
    pullUpHeight: 60,
    height: 40,
    autoRefresh: false,
    downContent: 'Release To Refresh',
    upContent: 'Pull Up To Refresh',
    loadingContent: 'Loading...',
    clsPrefix: 'xs-plugin-pullup-'
  };
};

var vendor = function vendor() {
  var el = document.createElement('div').style;
  var vendors = ['t', 'webkitT', 'MozT', 'msT', 'OT'];
  var transform;
  var i = 0;
  var l = vendors.length;

  for (; i < l; i++) {
    transform = vendors[i] + 'ransform';
    if (transform in el) return vendors[i].substr(0, vendors[i].length - 1);
  }

  return false;
}();

function prefixStyle(attrName) {
  if (vendor === false) return false;
  if (vendor === '') return attrName;
  return vendor + attrName.charAt(0).toUpperCase() + attrName.substr(1);
}

var transform = prefixStyle('transform');
export default {
  name: 'ScrollerCustomize',
  props: {
    value: {
      type: Object,
      default: function _default() {
        return {
          pulldownStatus: '',
          pullupStatus: ''
        };
      }
    },
    height: String,
    lockX: Boolean,
    lockY: Boolean,
    scrollbarX: Boolean,
    scrollbarY: Boolean,
    bounce: {
      type: Boolean,
      default: true
    },
    useOriginScroll: {
      type: Boolean,
      default: false
    },
    useTransition: {
      type: Boolean,
      default: true
    },
    preventDefault: {
      type: Boolean,
      default: false
    },
    stopPropagation: Boolean,
    boundryCheck: {
      type: Boolean,
      default: true
    },
    gpuAcceleration: {
      type: Boolean,
      default: true
    },
    usePulldown: {
      type: Boolean,
      default: false
    },
    usePullup: {
      type: Boolean,
      default: false
    },

    /**
     * refer to: http://xscroll.github.io/node_modules/xscroll/doc/PullDown.html
     */
    pulldownConfig: {
      type: Object,
      default: function _default() {
        return {};
      }
    },
    pullupConfig: {
      type: Object,
      default: function _default() {
        return {};
      }
    },
    enableHorizontalSwiping: {
      type: Boolean,
      default: false
    },
    scrollBottomOffset: {
      type: Number,
      default: 0
    }
  },
  methods: {
    reset: function reset(scrollPosition, duration, easing) {
      try {
        if (scrollPosition) {
          if (typeof scrollPosition.left !== 'undefined') {
            this._xscroll.scrollLeft(scrollPosition.left, duration, easing);
          }

          if (typeof scrollPosition.top !== 'undefined') {
            this._xscroll.scrollTop(scrollPosition.top, duration, easing);
          }
        }

        this._xscroll && this._xscroll.resetSize();
      } catch (error) {
        console.log('AutoConsole: reset -> error', error);
      }
    },
    donePulldown: function donePulldown() {
      var _this = this;

      this.pulldown && this.pulldown.reset(function () {
        _this.reset();
      });
      this.currentValue.pulldownStatus = 'default';
    },
    disablePullup: function disablePullup() {
      // this._xscroll.unplug(this.pullup)
      this.pullup && this.pullup.stop();
      this.currentValue.pullupStatus = 'disabled';
    },
    enablePullup: function enablePullup() {
      this.currentValue.pullupStatus = 'default';
      this.pullup && this.pullup.restart();
    },
    donePullup: function donePullup() {
      this.pullup.complete();
      this.reset();
      this.currentValue.pullupStatus = 'default';
    },
    getStyles: function getStyles() {
      var height = this.height;

      if (!this.height && this.$el && !this.$el.style.height && this.lockX) {
        height = "".concat(document.documentElement.clientHeight, "px");
        this.reset();
      }

      if (this.height && this.height.indexOf('-') === 0) {
        height = "".concat(document.documentElement.clientHeight + parseInt(this.height), "px");
      }

      this.styles = {
        height: "".concat(height)
      };
    }
  },
  created: function created() {
    var _this2 = this;

    if (!this.value) {
      this.currentValue = {
        pulldownStatus: '',
        pullupStatus: ''
      };
    } else {
      this.currentValue = this.value;
    }

    this.handleOrientationchange = function () {
      setTimeout(function () {
        _this2.reset();
      }, 100);
    };
  },
  data: function data() {
    return {
      currentValue: {},
      styles: {}
    };
  },
  watch: {
    currentValue: {
      handler: function handler(val) {
        this.$emit('input', pure(val));
      },
      deep: true
    },
    height: function height() {
      this.getStyles();
    },
    value: {
      handler: function handler(val) {
        if (val.pullupStatus === 'default' && this.currentValue.pullupStatus !== 'default') {
          this.donePullup();
        }

        if (val.pulldownStatus === 'default' && this.currentValue.pulldownStatus !== 'default') {
          this.donePulldown();
        }

        if (val.pullupStatus === 'disabled' && this.currentValue.pullupStatus !== 'disabled') {
          this.disablePullup();
        }

        if (val.pullupStatus === 'enabled' && this.currentValue.pullupStatus === 'disabled') {
          this.enablePullup();
        }
      },
      deep: true
    }
  },
  mounted: function mounted() {
    var _this3 = this;

    this.uuid = Math.random().toString(36).substr(3);
    this.$nextTick(function () {
      _this3.$el.setAttribute('id', "vux-scroller-".concat(_this3.uuid));

      var content = null;

      if (_this3.$slots.default) {
        content = _this3.$slots.default[0].elm;
      }

      if (!content) {
        throw new Error('no content is found');
      }

      _this3._xscroll = new XScroll({
        renderTo: _this3.$el,
        lockX: _this3.lockX,
        lockY: _this3.lockY,
        scrollbarX: _this3.scrollbarX,
        scrollbarY: _this3.scrollbarY,
        content: content,
        bounce: _this3.bounce,
        useOriginScroll: _this3.useOriginScroll,
        useTransition: _this3.useTransition,
        preventDefault: _this3.preventDefault,
        boundryCheck: _this3.boundryCheck,
        gpuAcceleration: _this3.gpuAcceleration,
        stopPropagation: _this3.stopPropagation
      }); // fix ios13 bug

      _this3._xscroll.getScrollTop = function () {
        var transY = _this3._xscroll && _this3._xscroll.container ? window.getComputedStyle(_this3._xscroll.container)[transform].match(/[-\d.*\d*e\-\d]+/g) : null;
        return transY ? Math.round(transY[5]) === 0 ? 0 : -Math.round(transY[5]) : 0;
      };

      _this3._xscroll.on('scroll', function () {
        if (_this3._xscroll) {
          var top = _this3._xscroll.getScrollTop();

          _this3.$emit('on-scroll', {
            top: top,
            left: _this3._xscroll.getScrollLeft()
          });

          var containerHeight = _this3._xscroll.containerHeight;
          var scrollHeight = _this3._xscroll.height;

          if (top >= containerHeight - scrollHeight - _this3.scrollBottomOffset) {
            _this3.$emit('on-scroll-bottom');
          }
        }
      }, {
        passive: true
      });

      if (_this3.usePulldown) {
        // if use slot=pulldown
        var container = _this3.$slots.pulldown;
        var config = objectAssign(pulldownDefaultConfig(), _this3.pulldownConfig);

        if (container) {
          config.container = container[0].elm;
        }

        _this3.pulldown = new Pulldown(config);

        _this3._xscroll.plug(_this3.pulldown);

        _this3.pulldown.on('loading', function (e) {
          _this3.$emit('on-pulldown-loading', _this3.uuid);
        });

        _this3.pulldown.on('statuschange', function (val) {
          _this3.currentValue.pulldownStatus = val.newVal;
        });
      }

      if (_this3.usePullup) {
        // if use slot=pullup
        var _container = _this3.$slots.pullup;

        var _config = objectAssign(pullupDefaultConfig(), _this3.pullupConfig);

        if (_container) {
          _config.container = _container[0].elm;
        }

        _this3.pullup = new Pullup(_config);

        _this3._xscroll.plug(_this3.pullup);

        _this3.pullup.on('loading', function (e) {
          _this3.$emit('on-pullup-loading', _this3.uuid);
        });

        _this3.pullup.on('statuschange', function (val) {
          _this3.currentValue.pullupStatus = val.newVal;
        });
      }

      if (_this3.enableHorizontalSwiping) {
        _this3._xscroll.on('panstart', function (e) {
          if (e.direction === 2 || e.direction === 4) {
            e.preventDefault();

            if (_this3.scrollbarY) {
              _this3._xscroll.userConfig.scrollbarY = false;
            }

            _this3._xscroll.userConfig.lockY = true;
          }
        });

        _this3._xscroll.on('panend', function () {
          if (_this3.scrollbarY) {
            _this3._xscroll.userConfig.scrollbarY = true;
          }

          _this3._xscroll.userConfig.lockY = false;
        });
      }

      _this3._xscroll.render();

      window.addEventListener('orientationchange', _this3.handleOrientationchange, false);
    });
    this.getStyles();
  },
  updated: function updated() {
    this.reset();
  },
  beforeDestroy: function beforeDestroy() {
    if (this.pullup) {
      this._xscroll.unplug(this.pullup);

      this.pullup.pluginDestructor();
    }

    if (this.pulldown) {
      this._xscroll.unplug(this.pulldown);

      this.pulldown.pluginDestructor();
    }

    window.removeEventListener('orientationchange', this.handleOrientationchange, false);
    this._xscroll && this._xscroll.destroy();
    this._xscroll = null;
  }
};

function pure(obj) {
  return JSON.parse(JSON.stringify(obj));
}